import { render, staticRenderFns } from "./roleDeleteConformationDialog.vue?vue&type=template&id=14569a9d&scoped=true&"
import script from "./roleDeleteConformationDialog.vue?vue&type=script&lang=js&"
export * from "./roleDeleteConformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14569a9d",
  null
  
)

export default component.exports